import DefaultLink from 'components/common/DefaultLink';
import Text from 'components/common/Text';
import TermsOfService from 'components/shared/TermsOfService';

const UsaaLegal = () => {
  return (
    <div className="mt-6 text-left leading-6">
      <Text brandStylesOverrides="textMd text-light">
        **Offer limited to one per household. New customers only. May not be combined with other
        offers. May not be used for gift cards. Not redeemable for cash. Not eligible in all states.
        Percent discount does not apply to any delivery charge. Click
        <TermsOfService classNames="ml-1 text-charcoal-90" text="here" /> for additional details.
        Void where prohibited.
      </Text>
      <Text brandStylesOverrides="textMd text-light" className="my-3">
        USAA means United Services Automobile Association and its affiliates.
      </Text>
      <Text brandStylesOverrides="textMd text-light" className="my-3">
        Use of the term "member" or "membership" refers to membership in USAA Membership Services
        and does not convey any legal or ownership rights in USAA. Restrictions apply and are
        subject to change.
      </Text>
      <Text brandStylesOverrides="textMd text-light" className="my-3">
        The trademarks, logos and names of other companies, products and services are the property
        of their respective owners.
      </Text>
      <Text brandStylesOverrides="textMd text-light" className="my-3">
        The USAA Perks program is provided through USAA Alliance Services LLC, a wholly owned
        subsidiary of USAA. USAA Alliance Services contracts with companies not affiliated with USAA
        to offer their products and services to members and customers. USAA Alliance Services
        receives compensation from these companies based on the sale of these products or services.
        When you purchase a product or service from one of these companies, that company is
        responsible for protecting your data and its processes and procedures may differ from those
        of USAA. These companies have sole financial responsibility for their products and services.
      </Text>
      <DefaultLink
        isExternal
        className="p-0 text-red-100 underline"
        target="_blank"
        to="https://www.usaaperks.com"
      >
        Return to USAA Perks
      </DefaultLink>
      <Text brandStylesOverrides="textMd text-light" className="mb-3 mt-0">
        #6431512.3.0325
      </Text>
    </div>
  );
};

export default UsaaLegal;
